export default __webpack_public_path__ + "static/media/2ndCard.34cac887.jpg";